import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { requestSaveContact } from "../../Redux/actions";
import { bindActionCreators } from "redux";
import { add } from "date-fns";
import { o } from "@table-library/react-table-library/styles-492c6342";

function ContactAdd(props) {
    const [error, seterror] = useState("");
    const [erroraddress, seterroraddress] = useState("");
    const [errorzipcode, seterrorzipcode] = useState("");
    const [errorroomno, seterrorroomno] = useState("");
    const [errorphoneno, seterrorphone_no] = useState("");
    const [erroremail, seterroremail] = useState("");
    const [id, setid] = useState(0);
    const [addressId, setaddressId] = useState(0);
    const [addmodal, setaddModal] = useState(false);
    const [user, setuser] = useState(null);
    const [contact, setContact] = useState({
        clientName: "", emailID: "", phoneNo: "", roomNo: "", address: "", zipcode: "", orderType: "daily", token: ""
    });

    function validateadd() {
        let formIsValid = false;
        if (!contact.clientName) {
            formIsValid = false;
            seterror("*Enter Contact Name.");
        } else {
            formIsValid = true;
            seterror("");
        }
        return formIsValid;
    }

    function validateEmail() {
        let formIsValid = false;
        if (!contact.emailID) {
            formIsValid = false;
            seterroremail("*Enter Contact email.");
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(contact.emailID)) {
            formIsValid = false;
            seterroremail("*Enter valid email.");
        } else {
            formIsValid = true;
            seterroremail("");
        }
        return formIsValid;
    }
    function validatePhoneNo() {
        let formIsValid = false;
        if (!contact.phoneNo) {
            formIsValid = false;
            seterrorphone_no("*Enter Contact phone no.");
        } else if (!/^\d{10}$/.test(contact.phoneNo)) {
            formIsValid = false;
            seterrorphone_no("*Enter valid phone no.");
        } else {
            formIsValid = true;
            seterrorphone_no("");
        }
        return formIsValid;
    }

    function validateaddress() {
        let formIsValid = false;
        if (addressId === "0") {
            formIsValid = false;
            seterroraddress("*Select contact address.");
        } else if (typeof addressId === "undefined") {
            formIsValid = false;
            seterroraddress("*Select contact address.");
        } else {
            formIsValid = true;
            seterroraddress("");
        }
        return formIsValid;
    }

    function validatezipcode() {
        let formIsValid = false;
        if (!contact.zipcode) {
            formIsValid = false;
            seterrorzipcode("*Enter Contact zipcode.");
        } else if (!/^\d{6}$/.test(contact.zipcode)) {
            formIsValid = false;
            seterrorzipcode("*Enter valid zipcode.");
        } else {
            formIsValid = true;
            seterrorzipcode("");
        }
        return formIsValid;
    }

    function validateroomNo() {
        let formIsValid = false;
        if (!contact.roomNo) {
            formIsValid = false;
            seterrorroomno("*Enter Room No.");
        } else if (/^.$/.test(contact.roomNo)) {
            formIsValid = false;
            seterrorroomno("*Enter valid Room No.");
        } else {
            formIsValid = true;
            seterrorroomno("");
        }
        return formIsValid;
    }

    function validateAddForm() {
        let validate = validateadd(); let phone = validatePhoneNo(); let address = validateaddress(); let zipcode = validatezipcode();
        let roomNo = validateroomNo();
        let valid = validate && address && phone && zipcode && roomNo;
        console.log("valid", validate, phone, address, zipcode, roomNo);
        if (!valid) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please fill all the required fields correctly.",
            });
        }
        return valid;
    }
    function onchangeadddata(e) {
        setContact((adddata) => ({
            ...adddata,
            [e.target.name]: e.target.value,
        }));
    }
    const addtoggle = () => setaddModal(!addmodal);
    const handleCancel = (e) => {
        // e.preventDefault(); // Safeguards against form submission
        addtoggle();    // Close the modal
    };

    const saveaddtoggle = (e) => {
        e.preventDefault();
        if (validateAddForm()) {
            let data1 = JSON.parse(localStorage.getItem("user"));
            if (data1) {
                console.log(data1);
                props.requestSaveContact({
                    data: {
                        userToken: data1.data.userToken,
                        compToken: localStorage.getItem("companyToken"),
                        token: contact.token,
                        clientName: contact.clientName,
                        zipcode: contact.zipcode,
                        address: contact.address,
                        roomNo: contact.roomNo,
                        emailID: contact.emailID,
                        phoneNo: contact.phoneNo,
                        orderType: contact.orderType,
                    },
                });
            }
        }
    };

    useEffect(() => {
        let candidateprofile = props.data.saveContactData;

        if (candidateprofile !== undefined) {
            if (candidateprofile?.data?.status == 1) {
                setContact({
                    clientName: "",
                    address: "",
                    roomNo: "",
                    email: "",
                    phoneno: "",
                    zipcode: "",
                    orderType: "daily",
                    token: "",
                });
                addtoggle();
                if (candidateprofile?.data?.data) {
                    console.log(candidateprofile.data.data);
                    localStorage.setItem("contacts", candidateprofile.data.data);
                }
                Swal.fire("Good job!", candidateprofile?.data?.message, "success");
                props.data.saveContactData = undefined;
                candidateprofile = undefined;
            } else {
                Swal.fire("Error!", `${candidateprofile.data.message}`, "error");
            }
        }
    }, [props.data.saveContactData]);

    function onchangeadddata(e) {
        if (e.target.type === 'radio') {
            console.log(e.target.value);
            setContact((data) => ({
                ...data,
                [e.target.name]: e.target.value,
            }));
        } else {
            setContact((data) => ({
                ...data,
                [e.target.name]: e.target.value,
            }));
        }
    }

    return (
        contact === null ? <div>Loading...</div> :
            <div className="contact-view">
                <form class="forms-sample">
                    <div class="form-group">
                        <label>Name</label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Name"
                            name="clientName"
                            value={contact.clientName}
                            onBlur={validateadd}
                            onChange={onchangeadddata}
                        />
                        {error && <p>{error}</p>}
                        <label> <br /> Room No. </label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Room no"
                            name="roomNo"
                            value={contact.roomNo}
                            onBlur={validateroomNo}
                            onChange={onchangeadddata}
                        />
                        {errorroomno && <p>{errorroomno}</p>}
                        <label> <br /> Address </label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Address"
                            name="address"
                            value={contact.address}
                            onBlur={validateaddress}
                            onChange={onchangeadddata}
                        />
                        {erroraddress && <p>{erroraddress}</p>}
                        <label> <br /> Zip code </label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Zipcode"
                            name="zipcode"
                            value={contact.zipcode}
                            onBlur={validatezipcode}
                            onChange={onchangeadddata}
                        />
                        {errorzipcode && <p>{errorzipcode}</p>}
                        <label> <br /> Email </label>
                        <input
                            type="email"
                            class="form-control"
                            placeholder="Email"
                            name="emailID"
                            value={contact.emailID}
                            onChange={onchangeadddata}
                        />
                        <label> <br /> Phone No </label>
                        <input
                            type="tel"
                            class="form-control"
                            placeholder="Phone No"
                            name="phoneNo"
                            value={contact.phoneNo}
                            onBlur={validatePhoneNo}
                            onChange={onchangeadddata}
                        />
                        {errorphoneno && <p>{errorphoneno}</p>}
                        <div class="form-check form-check-inline">
                            <input
                                class="form-check-input"
                                type="radio"
                                style={{ margin: "0px" }}
                                id="daily"
                                name="orderType"
                                value="daily"
                                checked={contact.orderType === "daily"}
                                onChange={onchangeadddata}
                            />
                            <label class="form-check-label">Daily</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input
                                class="form-check-input"
                                type="radio"
                                style={{ margin: "0px" }}
                                id="alternate"
                                name="orderType"
                                value="alternate"
                                // onBlur={validategender}
                                checked={contact.orderType === "alternate"}
                                onChange={onchangeadddata}
                            />
                            <label class="form-check-label">Alternate</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input
                                class="form-check-input"
                                type="radio"
                                style={{ margin: "0px" }}
                                id="onetime"
                                name="orderType"
                                value="onetime"
                                // onBlur={validategender}
                                checked={contact.orderType === "onetime"}
                                onChange={onchangeadddata}
                            />
                            <label class="form-check-label">One Time</label>
                        </div>
                    </div>
                    <button
                        type="submit"
                        class="btn btn-primary me-2"
                        onClick={saveaddtoggle}
                    >
                        Submit
                    </button>
                    {/* <button
                        type="button"
                        class="btn btn-light"
                        onClick={handleCancel}
                    >
                        Cancel
                    </button> */}
                </form>
            </div>
    )
}

const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestSaveContact }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContactAdd);